export const DORM = 'DORM';
export const OWN_MORTGAGE = 'OWN_MORTGAGE';
export const MORTGAGE = 'MORTGAGE';
export const OTHER = 'OTHER';
export const OWN = 'OWN';
export const OWNER = 'OWNER';
export const OWNERHOUSE = 'OWNERHOUSE';
export const OWNERAPARTMENT = 'OWNERAPARTMENT';
export const RENT = 'RENT';
export const WITH_PARENT = 'WITH_PARENT';
export const WITH_PARENTS = 'WITH_PARENTS';
export const WITH_PARENTS_BOARDING = 'WITH_PARENTS_BOARDING';
export const BOARDING = 'BOARDING';
export const OWN_NO_MORTGAGE = 'OWN_NO_MORTGAGE';

export const allResidenceTypes = [
  { type: DORM, title: 'residence.dorm', intl: true },
  { type: OWN_MORTGAGE, title: 'residence.own.mortgage', intl: true },
  { type: OTHER, title: 'residence.other', intl: true },
  { type: OWN, title: 'residence.owner', intl: true },
  { type: OWNER, title: 'residence.owner', intl: true },
  { type: OWNERHOUSE, title: 'residence.ownerhouse', intl: true },
  { type: OWNERAPARTMENT, title: 'residence.ownerapartment', intl: true },
  { type: RENT, title: 'residence.rent', intl: true },
  { type: WITH_PARENT, title: 'residence.with_parent', intl: true },
  { type: WITH_PARENTS, title: 'residence.with_parents', intl: true },
  { type: WITH_PARENTS_BOARDING, title: 'residence.with_parents_boarding', intl: true },
  { type: BOARDING, title: 'residence.boarding', intl: true },
  { type: OWN_NO_MORTGAGE, title: 'residence.own.not.mortgage', intl: true },
];

export const allResidenceTypeValues = allResidenceTypes.map((item) => item.type);

export const eeResidence = [
  { type: OWNER, title: 'residence.owner', intl: true },
  { type: RENT, title: 'residence.rent', intl: true },
  { type: WITH_PARENTS, title: 'residence.with_parents', intl: true },
  { type: DORM, title: 'residence.dorm', intl: true },
  { type: OTHER, title: 'residence.other', intl: true },
];
export const eeResidenceValues = eeResidence.map((item) => item.type);

export const ltResidence = [
  { type: RENT, title: 'residence.rent', intl: true },
  { type: OWNERHOUSE, title: 'residence.ownerhouse', intl: true },
  { type: OWNERAPARTMENT, title: 'residence.ownerapartment', intl: true },
  { type: WITH_PARENTS, title: 'residence.with_parents', intl: true },
  { type: DORM, title: 'residence.dorm', intl: true },
];
export const ltResidenceValues = ltResidence.map((item) => item.type);

export const lvResidence = [
  { type: OWN, title: 'residence.owner', intl: true },
  { type: RENT, title: 'residence.rent', intl: true },
  { type: OTHER, title: 'residence.other', intl: true },
];
export const lvResidenceValues = lvResidence.map((item) => item.type);

export const fiResidence = [
  { type: RENT, title: 'residence.rent', intl: true },
  { type: OWN, title: 'residence.owner', intl: true },
  { type: OTHER, title: 'residence.other', intl: true },
];
export const fiResidenceValues = fiResidence.map((item) => item.type);

export const mxResidence = [
  { type: RENT, title: 'residence.rent', intl: true },
  { type: OWN, title: 'residence.owner', intl: true },
  { type: WITH_PARENT, title: 'residence.with_parent', intl: true },
];
export const mxResidenceValues = mxResidence.map((item) => item.type);

export const esResidence = [
  { type: RENT, title: 'residence.rent', intl: true },
  { type: OWN, title: 'residence.owner', intl: true },
  { type: WITH_PARENT, title: 'residence.with_parent', intl: true },
  { type: OTHER, title: 'residence.other', intl: true },
];
export const esResidenceValues = esResidence.map((item) => item.type);

export const auResidenceUpgrade = [
  { type: RENT, title: 'residence.rent', intl: true },
  { type: OWNER, title: 'residence.owner', intl: true },
  { type: WITH_PARENTS_BOARDING, title: 'residence.with_parents_boarding', intl: true },
  { type: MORTGAGE, title: 'residence.mortgage', intl: true },
  { type: OTHER, title: 'residence.other', intl: true },
];

export const auResidence = [
  { type: BOARDING, title: 'residence.boarding', intl: true },
  { type: RENT, title: 'residence.rent', intl: true },
  { type: OWN_MORTGAGE, title: 'residence.own.mortgage', intl: true },
  { type: OWN_NO_MORTGAGE, title: 'residence.own.not.mortgage', intl: true },
];
export const auResidenceValues = auResidence.map((item) => item.type);

export default function getResidenceOptionsByCountry(countryCode) {
  switch (countryCode) {
    case 'LV':
      return lvResidence;
    case 'LT':
      return ltResidence;
    case 'FI':
      return fiResidence;
    case 'MX':
      return mxResidence;
    case 'ES':
      return esResidence;
    case 'AU':
      return auResidence;
    default:
      return eeResidence;
  }
}
